var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27778 1.53918L20 1.53996M6.27778 8.00075L20 8.00162M6.27778 14.4623L20 14.4632M1.52778 1.53846H1.53833M1.52778 8H1.53833M1.52778 14.4615H1.53833M2.05556 1.53846C2.05556 1.83584 1.81926 2.07692 1.52778 2.07692C1.2363 2.07692 1 1.83584 1 1.53846C1 1.24108 1.2363 1 1.52778 1C1.81926 1 2.05556 1.24108 2.05556 1.53846ZM2.05556 8C2.05556 8.29734 1.81926 8.53846 1.52778 8.53846C1.2363 8.53846 1 8.29734 1 8C1 7.70266 1.2363 7.46154 1.52778 7.46154C1.81926 7.46154 2.05556 7.70266 2.05556 8ZM2.05556 14.4615C2.05556 14.7589 1.81926 15 1.52778 15C1.2363 15 1 14.7589 1 14.4615C1 14.1642 1.2363 13.9231 1.52778 13.9231C1.81926 13.9231 2.05556 14.1642 2.05556 14.4615Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/bookingIcon.8f369dc4efe3dfee5c3a94e22ff220f2.svg";
export { ForwardRef as ReactComponent };